import IAuthzClient from '../../../clients/stratus/authz/IAuthzClient';
import bindAllMethods from '../../../utils/bindAllMethods';
import { ILogoutClient } from '../../../clients/shell/logout';
import { Stack } from '../../../core/types/stratus';
import ILogoutService from './ILogoutService';
import { ISessionService } from '..';
import { SetServiceDependencies } from '../../../infra/startup/types';
import { StateParamHandlerService } from '../../../services/stateParamHandlerService';
import { StatesParamType } from '../../../services/stateParamHandlerService/types';
import { LogoutOptionsType } from '../ISessionService';
import BaseLogoutService from './BaseLogoutService';

export type StratusLogoutServiceParameters = {
  stack: Stack;
  logoutClient: ILogoutClient;
  authzClient: IAuthzClient;
  sessionService: ISessionService;
};

export default class StratusLogoutService
  extends BaseLogoutService
  implements ILogoutService
{
  private _stack: Stack;
  private _logoutClient: ILogoutClient;
  private _authzClient: IAuthzClient;
  private _sessionService: ISessionService;
  private _stateParamHandlerService: StateParamHandlerService;

  public setDependencies({ clients, services }: SetServiceDependencies): void {
    const { stratus, shell } = clients;
    const {
      applicationService,
      sessionService,
      stateParamHandlerService,
      navigationService,
      localizationService
    } = services;
    this._stack = applicationService.getAuthStack();
    this._logoutClient = shell.logoutClient;
    this._authzClient = stratus.authzClient;
    this._sessionService = sessionService;
    this._stateParamHandlerService = stateParamHandlerService;
    this._navigationService = navigationService;
    this._localizationService = localizationService;

    bindAllMethods(this);
  }

  public async logout(options?: LogoutOptionsType): Promise<void> {
    const { postLogoutRedirect, email } = options || {};

    const stateParamObject: StatesParamType =
      this._stateParamHandlerService.createLogoutStateObject(
        postLogoutRedirect || this.getPostLogoutRedirectFallBack(),
        email
      );

    const postLogoutRedirectUrl = this._logoutClient.configureLogoutUrl(
      location.origin
    );

    const redirectTo = this._authzClient.configureLogoutUrl(
      this._stack,
      this._sessionService.getIdToken(),
      postLogoutRedirectUrl,
      stateParamObject?.state,
      email
    );

    return new Promise(() => {
      this._navigationService.redirect(redirectTo);
    });
  }
}
